<div class="loading-overlay" aria-busy="true" aria-label="Loading content">
  <mat-spinner diameter="48"></mat-spinner>
</div>
